import { render, staticRenderFns } from "./StuRecord.vue?vue&type=template&id=5bb3c779&scoped=true&"
import script from "./StuRecord.vue?vue&type=script&lang=js&"
export * from "./StuRecord.vue?vue&type=script&lang=js&"
import style0 from "./StuRecord.vue?vue&type=style&index=0&id=5bb3c779&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb3c779",
  null
  
)

export default component.exports